import React, { useRef, useEffect, useCallback, useState} from 'react';
import PackPresets from './PackPresets.js';
import {usePresets} from "components/installation/usePresets.js";
import {useWindowClearer} from "components/sidebar/useWindowClearer.js"
import {setSampleExplorerSelected} from 'actions/index.js';
import PresetIcon from './getPresetStyle.js';
import {
    setGroupPresetsByPacks,
    setPresetDragging} from 'actions/index.js';
import PresetsToolbar from './PresetsToolbar.js';
import Documented from 'components/help/Documented.js';
import {CHOOSE_INSTRUMENT_PRESET,
        FILTER_INSTRUMENT_TAG,
        INSTRUMENT_FX_LOAD ,
        INSTRUMENT_MODS_LOAD}  from 'constants/contextual-help.js';
import PresetOption from './PresetOption.js';
import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import {INSTRUMENT_RACK} from 'constants/track-types.js';
import {auditionPreset} from 'operations/actions.js';
import {useScroll} from 'components/selector2/useScroll.js';
import ethereum from 'decentralized/ethereum.js';
import {getPresetTags} from 'decentralized/presets/getPresetTags.js';
import {searchPresets} from 'decentralized/presets/PresetsSearcher.js';
import {connect} from 'react-redux';

const PresetsExplorer = ({
    track,
    content,
    isLoading,
    oscillator,
    setGroupByPacks,
    groupByPacks,
    explorerMaximized,
    children,
    type=MULTI_SYNTH,
    hideTags=false,
    searchText,
    setPresetDragging,
    guildId,
    setSampleExplorerSelected,
    zobject,
    sampleExplorerSelected,
    initialSize=30,
    isPianoRoll
}) => { 
    let ref = useRef(undefined);
    let [loaded, setLoaded] = useState(true);
    let [presetsToShow, setPresetsToShow] = useState([]);
    let [initSize, setInitSize] = useState(initialSize);
    let [searchTerm, setSearchTerm] = useState('');
    let {size} = useScroll(ref, initSize, true, searchTerm);
    let [lfos, setLFOs] = useState(true);
    let [fx, setFX] = useState(false);
    let [filterFavorites, setFilterFavorites] = useState(false);
    const {
        searchTermExecuted,
        presets,
        tags,
        instrumentType,
        setInstrumentType,
        presetsByPack
    } = usePresets({guildId, setGroupByPacks, filterFavorites, type, track, searchTerm, groupByPacks});

    useEffect(() => {
        if (filterFavorites) {
            setGroupByPacks(false);
        }
    }, [filterFavorites, setGroupByPacks]);

    useEffect(() => {
        if (searchTerm !== "") {
            setGroupByPacks(false);
        }
    }, [searchTerm, setGroupByPacks]);

    useEffect(() => {
        setTimeout(() => {
            if (ref.current) {
                let newSize = ref.current.offsetHeight / 15;
                setInitSize(newSize);
            }
        }, 100);
    }, [ref.current && ref.current.offsetHeight, setInitSize, explorerMaximized]);

    useEffect(() => {
        if (isLoading) {
            setLoaded(false);
        } else {
            setLoaded(true);
        }
    }, [isLoading, setLoaded]);

    useWindowClearer({
        clear: () => setSampleExplorerSelected(false),
        selected: sampleExplorerSelected
    });

    useEffect(() => {
        return () => setSampleExplorerSelected(false);
    }, []);

    const _auditionPreset = useCallback(async (preset) => {
        setLoaded(false);
        if (oscillator) {
            oscillator.loadFormantsPreset(preset);
        } else if (track) {
            await track.sequencerEngine
                .operationManager.dispatch(
                    auditionPreset(preset, track, lfos, fx));
        } else if (zobject) {
            zobject.loadPreset(preset);
        }
        setLoaded(true);
    }, [oscillator, zobject, track, fx, lfos, setLoaded]);

    useEffect(() => {
        setPresetsToShow(presets);
    }, [presets, setPresetsToShow]);

    useEffect(() => {
        if (track) {
            track.browsedPresets = presetsToShow;
        }
    }, [track, presetsToShow]);

    useEffect(() => {
        if (!groupByPacks) {
            let _s = searchTerm.toLowerCase();
            _s.trim();
            if (_s === '') {
                setPresetsToShow(presets);
                return;
            }
            setPresetsToShow(presets.filter(
                x => x.title.toLowerCase().includes(_s) ||
                    x.tags.some(tag => tag.toLowerCase().includes(_s))));
        }
    }, [groupByPacks, searchTerm, setPresetsToShow, presets]);
    
    const onChange = useCallback((e, searchTerm) => {
        let _x = searchTerm === undefined && e ?  e.target.value : searchTerm;
        setSearchTerm(_x);
   }, [setSearchTerm, setPresetsToShow, presets]);

    const clearSearch = useCallback(() => {
        setSearchTerm('');
        setPresetsToShow(presets);
    }, [setSearchTerm, setPresetsToShow, presets]);

    let className = "sample-explorer";
    if (!loaded) {
        className += " loading-bull-shit-fuck";
    }

    if (sampleExplorerSelected) {
        className += " selected";
    }

    let resultType = "presets";
    let numPresets = presetsToShow.length;
    if (groupByPacks) {
        if (searchTerm !== "") {
            numPresets = presetsByPack.reduce(
                (a,b) => b.matchingContent.length + a, 0);
        } else {
            numPresets = presetsByPack.length;
            resultType = "packs with presets";
        }
    }

    if (zobject && searchTerm === "" && numPresets === 0) {
        return '';
    }
    let _presets = presetsToShow.slice(0, Math.floor(size));
    return (
        <div
          onMouseDown={(e) => {
              // e.stopPropagation();
              setSampleExplorerSelected(true);
          }}
          className={zobject ? "zobject-presets presets-explorer-container" : "presets-explorer-container"}>
        <div className={className}>
          {children}
          <div className="explorer-top">
            <div className="explorer-row">
            <PresetsToolbar
              type={type}
              groupByPacks={groupByPacks}
              setGroupByPacks={setGroupByPacks}
              setFilterFavorites={setFilterFavorites}
              filterFavorites={filterFavorites}
              setInstrumentType={setInstrumentType}
              instrumentType={instrumentType}
              setSearchTerm={setSearchTerm}
              setPresetsToShow={setPresetsToShow}
              searchTerm={searchTerm}
              tags={tags}
              onChange={onChange}/>
            <div className="override-label">
              Override
            </div>
            <Documented
              element={INSTRUMENT_FX_LOAD}
              onClick={() => setFX(!fx)}
              className={fx ? "explorer-option selected" :"explorer-option"}>FX</Documented>
            </div>
          <div className="presets-search-container">
            <input value={searchTerm} type={"text"} onChange={onChange} placeholder={zobject ? "Search for presets" : "Search for synths"}/>
            <div onClick={clearSearch} className="search-clear-button">x</div>
          </div>
          </div>
         <div ref={ref} className="presets-list">
            {groupByPacks ?
             presetsByPack.map(
                 (pack, i) =>
                     <PackPresets
                       searchTerm={searchTermExecuted}
                       guildId={guildId}
                       content={content}
                       setPresetDragging={setPresetDragging}
                       scrollRef={ref}
                       _auditionPreset={_auditionPreset}
                       isPianoRoll={isPianoRoll}
                       filterFavorites={filterFavorites}
                       instrumentType={instrumentType}
                       pack={pack}
                       key={pack.packHash}/>)
             : _presets.map(
                (preset, i) =>
                    <PresetOption key={i}
                                  isPianoRoll={isPianoRoll}
                                  preset={preset}
                                  scrollRef={ref}
                                  currentPreset={content}
                                  setPresetDragging={setPresetDragging}
                                  _auditionPreset={_auditionPreset}
                    />)}
          </div>
       </div>
          {hideTags ? 
           <div className="preset-tags-chooser">
             {tags.map(x =>
                       <Documented
                         element={FILTER_INSTRUMENT_TAG}
                         arg={x}
                         onClick={() => x === searchTerm ? onChange(undefined, "") : onChange(undefined, x)}
                         className={searchTerm === x ? "preset-tag selected " : "preset-tag"}>{x}</Documented>)}
           </div> : ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0,
      sampleExplorerSelected: state.selector.sampleExplorerSelected,
      isLoading: props.track && props.track.trackIsLoading,
      explorerMaximized: state.selector.explorerMaximized,
      groupByPacks: state.presets.groupByPacks
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setGroupByPacks: x => dispatch(setGroupPresetsByPacks(x)),
      setPresetDragging: (preset) => dispatch(setPresetDragging(preset)),
      setSampleExplorerSelected: (x) => dispatch(setSampleExplorerSelected(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresetsExplorer);
